import { ActionTypes } from "../constants/action-types";

export const setFiltering = ({flag, filtering}) => {
    switch(flag) {
        case "POVRCHY":
            return {
                type: ActionTypes.SET_FILTERING_POVRCHY,
                payload: filtering
            };
        case "DOPLNKY":
            return {
                type: ActionTypes.SET_FILTERING_DOPLNKY,
                payload: filtering
            };
        case "VYBAVENI":
            return {
                type: ActionTypes.SET_FILTERING_VYBAVENI,
                payload: filtering
            };
        default:
            return null;            
    }
};

export const changeFiltering = ({flag, rodina, doporuceni}) => {
    switch(flag) {
        case "POVRCHY":
            return { 
                type: ActionTypes.CHANGE_FILTERING_POVRCHY,
                payload: {rodina: rodina, doporuceni: doporuceni}
            }
        case "DOPLNKY":
            return { 
                type: ActionTypes.CHANGE_FILTERING_DOPLNKY,
                payload: {rodina: rodina, doporuceni: doporuceni}
            }
        case "VYBAVENI":
            return { 
                type: ActionTypes.CHANGE_FILTERING_VYBAVENI,
                payload: {rodina: rodina, doporuceni: doporuceni}
            }
        default:
            return null;           
    }
};
export const changeVisibility = (visibility) => {
    console.log("changeVisibility called")
    return {
        type: ActionTypes.CHANGE_FILTERING_VISIBILITY,
        payload: visibility
    }
};  
